module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_106-a2910f49a0cd96087c176b3eee90ef6b.png";